import { render, staticRenderFns } from "./app-privilege-success.vue?vue&type=template&id=400f0e1e&scoped=true&lang=pug&"
import script from "./app-privilege-success.vue?vue&type=script&lang=js&"
export * from "./app-privilege-success.vue?vue&type=script&lang=js&"
import style0 from "./app-privilege-success.vue?vue&type=style&index=0&id=400f0e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f0e1e",
  null
  
)

export default component.exports